export default __webpack_public_path__ + "fonts/foreclosure_factore.svg";